import { useState, useEffect, RefObject } from 'react';

const useOverflown = (ref: RefObject<HTMLElement>, variant: 'horizontal' | 'vertical'): boolean => {
  const [isOverflown, setIsOverflown] = useState(false);

  useEffect(() => {
    ref.current &&
      setIsOverflown(
        variant === 'horizontal' ? ref.current.scrollWidth - ref.current.clientWidth > 0 : ref.current.scrollHeight - ref.current.clientHeight > 0,
      );
  }, []);

  return isOverflown;
};

export default useOverflown;
